import keys from '@debbie/common/dist/cache/keys.js';
import q from './query.js';
export const createEntityCache = (entity) => {
    return {
        keys: {
            item: (id) => keys.read.item(entity, id),
            collection: keys.read.collection(entity),
        },
        invalidate: {
            create: () => q.invalidate(keys.write.create(entity)),
            modify: (id) => q.invalidate(keys.write.modify(entity, id)),
        },
    };
};
//# sourceMappingURL=invalidation.js.map